// Supabase client for Pista
// Automatically uses local Supabase for development, cloud Supabase for production

import { createClient } from "@supabase/supabase-js";
import logger from '../utils/logger';

// Get configuration from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

// Determine if we're using local Supabase
const isLocalSupabase = supabaseUrl.includes('localhost') || supabaseUrl.includes('127.0.0.1');

// Create and export the Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false
  },
});

// Log configuration for debugging
if (process.env.NODE_ENV === 'development') {
  logger.debug('Supabase Client Configuration', {
    url: supabaseUrl,
    isLocal: isLocalSupabase,
    environment: process.env.NODE_ENV,
  });
}

if (!supabaseUrl || !supabaseAnonKey) {
  logger.warn("Supabase environment variables are missing. Some features may not work correctly.");
}

export default supabase;
